import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import MobileNav from './MobileNav';
import NotificationToast from '../notifications/NotificationToast';

export default function Layout() {
  return (
    <div className="flex h-screen bg-gray-50 dark:bg-gray-950">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto bg-gray-50 dark:bg-gray-950">
          <div className="min-h-full flex flex-col">
            <div className="flex-1 p-4 md:p-6 pb-20 md:pb-6">
              <Outlet />
            </div>
            <Footer />
          </div>
        </main>
      </div>
      <MobileNav />
      <NotificationToast />
    </div>
  );
}
